import { OwnUpSmallBody } from '@rategravity/own-up-component-library';
import React from 'react';
import { WidgetWrapper } from '../common/WidgetWrapper';
import { RentOrBuyProvider } from './data/dataProvider';
import { Inputs } from './inputs';
import { CalculationSummary } from './summary';

const description = (
  <React.Fragment>
    <OwnUpSmallBody variant="body1">
      Rent vs. Buy Mortgage Calculator: Analyzing Housing Decisions
    </OwnUpSmallBody>
    <br />
    <OwnUpSmallBody variant="body1">
      This module calculates the potential benefits of buying a home as opposed to renting a home
      based on various given parameters. Returns a break down of the various costs of both buying vs
      renting, and a final value of money saved by buying. This final value may be negative to
      indicate a benefit of renting rather than buying.{' '}
    </OwnUpSmallBody>
  </React.Fragment>
);

export const RentOrBuyCalculator: React.FC = () => {
  return (
    <WidgetWrapper title="Rent or Buy Calculator" description={description}>
      <RentOrBuyProvider>
        <Inputs />
        <CalculationSummary />
      </RentOrBuyProvider>
    </WidgetWrapper>
  );
};
